/**
 * © 2025 Grupo Salamander SAPI de CV
 * Author: Pablo Adoue Peralta
 *
 * UIButtonTooltipWrapper: Conditionally wraps children with a Material UI Tooltip component.
 */

import { Tooltip } from '@mui/material'
import type React from 'react'

/**
 * Props for the tooltip wrapper component
 */
type TUIButtonTooltipWrapperProps = {
  tooltip: string | undefined
  children: React.ReactElement
}

/**
 * Conditionally wraps children with a tooltip if tooltip text is provided.
 * Returns unwrapped children if no tooltip is specified.
 *
 * MUI Tooltip requires the child to be able to hold a ref and forward events.
 * Wrapping in a span ensures proper event handling in all cases.
 *
 * @param props - Component props
 * @returns Wrapped or unwrapped children
 */
export function UIButtonTooltipWrapper(props: TUIButtonTooltipWrapperProps) {
  const { tooltip, children } = props

  if (typeof tooltip === 'string' && tooltip.length > 0) {
    return (
      <Tooltip title={tooltip} arrow>
        <span>{children}</span>
      </Tooltip>
    )
  }

  return children
}
